export default "__VITE_ASSET__CLakN2KY__"